import React from 'react';
import { DiNodejsSmall, DiLaravel } from 'react-icons/di';
import { FaDatabase } from 'react-icons/fa';
import { BsFillInfoCircleFill } from 'react-icons/bs';

const skills = [
  {
    id: 1,
    icon: <DiNodejsSmall />,
    title: 'Languages',
    knowledgeList: [
      {
        label: 'HTML5',
        perc: '100%',
      },
      {
        label: 'Javascript',
        perc: '98%',
      },
      {
        label: 'PHP',
        perc: '98%',
      },
      {
        label: 'Python',
        perc: '65%',
      },
      {
        label: 'Typescript',
        perc: '60%',
      },
      {
        label: 'Java',
        perc: '40%',
      },
      {
        label: 'Kotlin',
        perc: '40%',
      },
    ],
  },
  {
    id: 2,
    icon: <DiLaravel />,
    title: 'Framework & tools',
    knowledgeList: [
      {
        label: 'Express.js',
        perc: '95%',
      },
      {
        label: 'JQuery',
        perc: '100%',
      },
      {
        label: 'Laravel',
        perc: '90%',
      },
      {
        label: 'Websocket',
        perc: '95%',
      },
      {
        label: 'Sass',
        perc: '80%',
      },
      {
        label: 'Serverless',
        perc: '80%',
      },
      {
        label: 'React',
        perc: '75%',
      },
      {
        label: 'Lumen',
        perc: '70%',
      },
      {
        label: 'Vue',
        perc: '55%',
      },
      {
        label: 'NestJS',
        perc: '45%',
      },
      {
        label: 'NextJS',
        perc: '45%',
      },
    ],
  },
  {
    id: 3,
    icon: <FaDatabase />,
    title: 'Databases',
    knowledgeList: [
      {
        label: 'MariaDB / MySQL',
        perc: '90%',
      },
      {
        label: 'DynamoDB',
        perc: '88%',
      },
      {
        label: 'PostgreSQL',
        perc: '85%',
      },
      {
        label: 'MongoDB',
        perc: '85%',
      },
      {
        label: 'Redis',
        perc: '70%',
      },
      {
        label: 'SQLite',
        perc: '60%',
      },
    ],
  },
  {
    id: 4,
    icon: <BsFillInfoCircleFill />,
    title: 'Others',
    knowledgeList: [
      {
        label: 'Node',
        perc: '95%',
      },
      {
        label: 'GIT',
        perc: '95%',
      },
      {
        label: 'English',
        perc: '90%',
      },
      {
        label: 'AWS',
        perc: '88%',
      },
      {
        label: 'SonarQube',
        perc: '90%',
      },
      {
        label: 'Jest, Mocha (BDD & TDD)',
        perc: '90%',
      },
      {
        label: 'SCRUM',
        perc: '80%',
      },
      {
        label: 'Docker',
        perc: '80%',
      },
      {
        label: 'Centos',
        perc: '80%',
      },
      {
        label: 'Ubuntu',
        perc: '75%',
      },
      {
        label: 'Autocad',
        perc: '60%',
      },

    ],
  },
];

export default skills;
